export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TOGGLE_SIDEBAR_COLLAPSE: "TOGGLE_SIDEBAR_COLLAPSE",
  TOGGLE_THEME: "TOGGLE_THEME"
};
